const initialState = {
  'byId': new Map(),
  'loading': false,
  'sort': 'date'
};

export function workTrackersReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_WORK_TRACKERS':
      return {
        ...state,
        byId: action.payload,
      };
    case 'WORK_TRACKERS_LOADING': {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
